export default __webpack_public_path__ + "static/media/forsale.553144f8.png";